import { observer } from 'mobx-react-lite';
import { Countdown } from './countdown';
import { CircleLock } from './countdownLoader';
import { animationStore } from '../../../../store/animationStore';
import { CurrentAutoCashOutValue } from './currentAutoCashoutValue';
import { WinNotification } from './winNotification';
import { doBetStore } from '../../../../store';

export const GearAnimation = observer(({ gameTypeId }) => {
  const {
    isLightAnimationByGameType,
    finishBlueLightningAnim,
    isRotateByGameType,
    isGameClosedByGameType,
  } = animationStore;

  const {
    winData: { [gameTypeId]: winAmount },
  } = doBetStore;

  return (
    <div
      className={`pascal-game-col-mid ${isGameClosedByGameType[gameTypeId] ? 'inactive' : ''} ${
        isLightAnimationByGameType[gameTypeId] ? 'lightning' : ''
      }`}
    >
      <span className='g-line-1' />
      <span className='g-line-2' />
      {winAmount && <WinNotification winAmount={winAmount} />}
      <div className='pascal-game-col-mid-content'>
        <div className='mechanism1' />
        <div className='mechanism2' />
        <div className='pascal-game-col-top-area'>
          <div className='game-col-top-shadow-wrp'>
            <div className='game-col-top-shadow-ins' />
          </div>
          <div className='lightning-block-2-wrp'>
            <div className='lightning-block-2' />
          </div>
          <div className='lightning-block-3-wrp'>
            <div className='lightning-block-3' />
          </div>
        </div>
        <div
          className={`pascal-game-col-middle-area  ${
            finishBlueLightningAnim[gameTypeId] ? 'lose' : ''
          }`}
        >
          <div className='pascal-game-col-circle-wrp'>
            <CircleLock
              gameTypeId={gameTypeId}
              isGameClosed={isGameClosedByGameType[gameTypeId]}
              isRotate={isRotateByGameType[gameTypeId]}
            />
            <Countdown
              gameTypeId={gameTypeId}
              isGameClosed={isGameClosedByGameType[gameTypeId]}
              isRotate={isRotateByGameType}
            />
            <div className='game-col-lose-wrp'>
              <div className='game-col-lose-ins' />
            </div>
          </div>
        </div>
        <div className='pascal-game-col-bottom-area'>
          <div className='lightning-block-1-wrp'>
            <div className='lightning-block-1' />
          </div>
        </div>
        <CurrentAutoCashOutValue gameTypeId={gameTypeId} />
      </div>
    </div>
  );
});
